import { render, staticRenderFns } from "./expenseTemplates.vue?vue&type=template&id=2006e736&scoped=true"
import script from "./expenseTemplates.vue?vue&type=script&lang=js"
export * from "./expenseTemplates.vue?vue&type=script&lang=js"
import style0 from "./expenseTemplates.vue?vue&type=style&index=0&id=2006e736&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006e736",
  null
  
)

export default component.exports